import { IPanelStyles, IStackTokens, memoizeFunction, mergeStyleSets } from '@fluentui/react';
import { useScreen } from 'common/hooks/useScreen';
import { ScreenSize } from 'common/utilities';

const baseline = 8;

export const spacing = {
  xxl: baseline * 7,
  xl: baseline * 4,
  lg: baseline * 3,
  md: baseline * 2,
  sm: baseline * 1.5,
  xs: baseline,
  xxs: baseline * 0.5,
} as const;

const getStyles = memoizeFunction((screenSize: ScreenSize) => {
  return mergeStyleSets({
    panelPreviewTagHeader: {
      marginLeft: spacing.lg,
      marginRight: spacing.lg,
    },
    copilotStarterHeading: {
      marginTop: 20,
      marginBottom: spacing.sm,
    },
    copilotStarterSubheading: {
      textAlign: 'center',
      width: 177,
    },
  });
});

export const useChatControlStyles = () => {
  const { screenSize } = useScreen();
  return getStyles(screenSize);
};

export const useChatPanelStyles = (): Partial<IPanelStyles> => {
  return {
    content: {
      paddingLeft: 24,
      paddingRight: 24,
    },
  };
};

export const chatTokens = {
  root: { childrenGap: spacing.lg } as IStackTokens,
  copilotStarterRoot: { childrenGap: spacing.xl } as IStackTokens,
};
